import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";

import "./Modal.scss";

export const VK_ESCAPE = 27;

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    zIndex: 9123456
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 91234567,
    padding: 0
  }
};

/**
 * Modal
 */
class Modal extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    customStyles: PropTypes.object,
    children: PropTypes.node,
    title: PropTypes.node,
    isOpen: PropTypes.bool,
    hasCloseButton: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    onCancel: PropTypes.func,
    className: PropTypes.string
  };

  static defaultProps = {
    customStyles: {},
    className: null,
    title: null,
    children: null,
    isOpen: false,
    hasCloseButton: true,
    shouldCloseOnOverlayClick: true,
    onCancel: null
  };

  state = {
    isOpen: false
  };

  componentWillMount() {
    // on document so escape keydown works.. it won't work on window
    document.addEventListener("keydown", this.onKeyDown);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.isOpen !== nextProps.isOpen) {
      this.setState({ isOpen: nextProps.isOpen });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);
  }

  onKeyDown = e => {
    if (e.keyCode === VK_ESCAPE) {
      this.onCancel(e);
    }
  };

  onCancel = () => {
    this.setState({ isOpen: false });
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  render() {
    return (
      <ReactModal
        shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
        portalClassName={this.props.className}
        style={{
          overlay: {
            ...customStyles.overlay,
            ...this.props.customStyles.overlay
          },
          content: {
            ...customStyles.content,
            ...this.props.customStyles.content
          }
        }}
        ariaHideApp={false}
        isOpen={this.state.isOpen}
      >
        {(this.props.title || this.props.hasCloseButton) && (
          <div className="Modal__Title">
            <div className="Modal__Title__Title">{this.props.title}&nbsp;</div>
            {this.props.hasCloseButton && (
              <button className="btn btn-secondary Modal__Title__CloseButton" onClick={this.onCancel}>
                <div className="Modal__Title__CloseButton__Inner">
                  <i className="fa fa-times" />
                </div>
              </button>
            )}
          </div>
        )}
        <div className="Modal__Content">{this.props.children}</div>
      </ReactModal>
    );
  }
}

export default Modal;
